"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Turns a saved template into composer text: the built-in variables are
 * filled from the chat, and every other token stays as {{name}} for the
 * sender to fill in. The text is exactly what renderTemplate produces; this
 * adds where each filled value and each unresolved token sits, so the
 * composer can underline values and draw chips. */

var _templateRenderer = require('./templateRenderer');























/* The variables the app fills by itself. Any other name is custom. */
 const BUILT_IN_VARIABLES = ['first_name', 'last_name', 'staff_name', 'org_name', 'team_name'] 

















; exports.BUILT_IN_VARIABLES = BUILT_IN_VARIABLES

// Blank exactly when D1's renderer would treat the value as missing (ASCII
// whitespace only; a Unicode space is a value there too).
const isBlank = (value) =>
  !value || _templateRenderer.renderTemplate.call(void 0, '{{v}}', { v: value }).unresolved.length > 0

/* The chat's only patient, or null when it has none or several. */
 const onlyPatient = ({ patients }) =>
  patients.length === 1 ? patients[0] : null; exports.onlyPatient = onlyPatient

const PATIENT_VARIABLES = new Set(['first_name', 'last_name'])

/* Whether inserting the template here first asks who it's for: it uses a
 * patient's name and the chat has more than one patient. */
 const needsPatientChoice = (body, context) =>
  context.patients.length > 1 && _templateRenderer.templateTokens.call(void 0, body).some(token => PATIENT_VARIABLES.has(token.name)); exports.needsPatientChoice = needsPatientChoice

// The patient a template is for: the chat's only one, or the one picked.
const targetPatient = (context, patientKey) =>
  _nullishCoalesce(_nullishCoalesce(exports.onlyPatient.call(void 0, context), () => ( context.patients.find(p => p.PatientKey === patientKey))), () => ( null))

// The team {{team_name}} names, if any.
const targetTeam = ({ teamName, teamNames }) =>
  teamName !== undefined ? _nullishCoalesce(teamName, () => ( undefined)) : teamNames.length === 1 ? teamNames[0] : undefined

/* The values the chat fills in. patientKey is the patient the sender picked
 * in a chat with several; with one patient it isn't needed. */
 const templateValues = (context, patientKey) => {
  const { senderName, orgName } = context
  const patient = targetPatient(context, patientKey)
  const candidates = {
    first_name: _optionalChain([patient, 'optionalAccess', _ => _.FirstName]),
    last_name: _optionalChain([patient, 'optionalAccess', _2 => _2.LastName]),
    staff_name: senderName,
    org_name: orgName,
    team_name: targetTeam(context),
  }
  const values = {}
  for (const name of exports.BUILT_IN_VARIABLES) {
    const value = candidates[name]
    if (!isBlank(value)) values[name] = value
  }
  return values
}; exports.templateValues = templateValues

/* Built-in defaults for values that are truly missing for a known target, so
 * "Hi {{first_name}}," reads "Hi there," for a patient with no first name:
 * - first_name: "there", when the template is for a known patient (the chat's
 *   only one, or the one picked) whose first name is blank. With several
 *   patients and no pick yet, the target isn't known: no default.
 * - team_name: the org's name, when no team can be named.
 * last_name and custom variables have none; staff_name and org_name are
 * always known. A fallback typed in the template ({{x | …}}) always wins. */
 const templateDefaults = (context, patientKey) => {
  const defaults = {}
  const patient = targetPatient(context, patientKey)
  if (patient && isBlank(patient.FirstName)) defaults.first_name = 'there'
  const orgName = context.orgName
  if (isBlank(targetTeam(context)) && !isBlank(orgName)) defaults.team_name = orgName
  return defaults
}; exports.templateDefaults = templateDefaults

/* Renders each token with D1's renderTemplate, so the decision (value,
 * fallback or unresolved) is always the renderer's, and records where the
 * result landed. A token the renderer leaves unresolved (no value and no
 * typed fallback) takes its built-in default, if it has one. */
 const resolveTemplate = (body, values, defaults = {}) => {
  let text = ''
  let last = 0
  const filled = []
  const unresolved = []
  for (const token of _templateRenderer.templateTokens.call(void 0, body)) {
    text += body.slice(last, token.index)
    const start = text.length
    const result = _templateRenderer.renderTemplate.call(void 0, token.text, values)
    const fallback = result.unresolved.length > 0 && Object.prototype.hasOwnProperty.call(defaults, token.name) ? defaults[token.name] : undefined
    text += _nullishCoalesce(fallback, () => ( result.rendered))
    if (fallback !== undefined) {
      filled.push({ name: token.name, start, end: text.length })
    } else if (result.unresolved.length > 0) {
      unresolved.push({ name: token.name, start, end: text.length })
    } else if (result.rendered !== '') {
      filled.push({ name: token.name, start, end: text.length })
    }
    last = token.index + token.text.length
  }
  text += body.slice(last)
  return { text, filled, unresolved, missing: [...new Set(unresolved.map(r => r.name))] }
}; exports.resolveTemplate = resolveTemplate

/* A piece of a preview: plain text, or a blank still to fill, shown as a
 * highlighted "[date]". */


const blankLabel = (name) => `[${name.replace(/_/g, ' ').trim() || 'blank'}]`

/* The template as it reads in this chat: values, typed fallbacks and built-in
 * defaults filled in, every leftover blank as a "[name]" placeholder. */
 const previewTemplate = (body, values, defaults = {}) => {
  const resolved = exports.resolveTemplate.call(void 0, body, values, defaults)
  const segments = []
  let last = 0
  for (const blank of resolved.unresolved) {
    if (blank.start > last) segments.push({ text: resolved.text.slice(last, blank.start) })
    segments.push({ text: blankLabel(blank.name), blank: true })
    last = blank.end
  }
  if (last < resolved.text.length) segments.push({ text: resolved.text.slice(last) })
  return segments
}; exports.previewTemplate = previewTemplate

 const SAMPLE_PATIENT = { PatientKey: 'sample-patient' , FirstName: 'Alex', LastName: 'Rivera' }; exports.SAMPLE_PATIENT = SAMPLE_PATIENT

/* What Settings previews a template with, outside any chat: a sample patient
 * (Alex Rivera), the user's own team (or the org's first), the org, and the
 * user's own name. */
 const sampleTemplateContext = ({ senderName, orgName, teamName }) => ({
  patients: [exports.SAMPLE_PATIENT],
  senderName,
  orgName,
  teamNames: teamName ? [teamName] : [],
  teamName: _nullishCoalesce(teamName, () => ( null)),
}); exports.sampleTemplateContext = sampleTemplateContext
